import { API_ENDPOINTS } from "shared/constants";
import { APIService } from "shared/services";
import { IJSONAPIItem } from "shared/types";
import { IEquipment, IEquipmentCategory } from "Venues/types";

export class EquipmentService {
  static getEquipment = (params: {
    venue?: string;
    stage?: string;
    category?: IEquipmentCategory;
  }): Promise<IJSONAPIItem> =>
    new Promise(async (resolve, reject) => {
      try {
        const equipment = await APIService.get({
          path: API_ENDPOINTS.EQUIPMENT_LIST,
          data: params,
        });
        resolve(equipment);
      } catch (error) {
        reject(error);
      }
    });

  static createEquipment = (equipment: IEquipment): Promise<IJSONAPIItem> =>
    new Promise(async (resolve, reject) => {
      try {
        const createdEquipment = await APIService.post({
          path: API_ENDPOINTS.EQUIPMENT_LIST,
          data: equipment,
        });
        resolve(createdEquipment);
      } catch (error) {
        reject(error);
      }
    });

  static editEquipment = (id: string, equipment: IEquipment): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        const editedEquipment = await APIService.patch({
          path: API_ENDPOINTS.EQUIPMENT(id),
          data: equipment,
        });
        resolve(editedEquipment);
      } catch (error) {
        reject(error);
      }
    });

  static deleteEquipment = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.EQUIPMENT(id),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
}
